<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <div class="message-content" [innerHTML]="data.message"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button class="ok-btn" (click)="close()">
    OK
  </button>
</mat-dialog-actions>